const workspaceWithoutSessionId = ['zona-demand', 'compartir-desempeno'];

export const getIsFromWorkspaceWithoutSessionId = locationHref => {
  return workspaceWithoutSessionId.some(w => locationHref.includes(w));
};
